// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resizable {
  resize: vertical !important;
  line-height: 20px !important;
  min-height: 154px;
}

div.Controlled.Input input.Controlled, div.Controlled.Input textarea.Controlled.resizable {
  padding: 8px;
}

.default {
  padding: 8px 8px 4px 8px !important;
  line-height: 20px !important;
}

.invoiceEditor-footer {
  height: 80px !important;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/AreaInput.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,4BAAA;EACA,iBAAA;AACJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,mCAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,uBAAA;AAAJ","sourcesContent":[".resizable {\n    resize: vertical !important;\n    line-height: 20px !important;\n    min-height: 154px;\n\n}\n\ndiv.Controlled.Input input.Controlled, div.Controlled.Input textarea.Controlled.resizable {\n    padding: 8px;\n}\n\n.default { \n    padding: 8px 8px 4px 8px !important;\n    line-height: 20px !important;\n}\n\n.invoiceEditor-footer {\n    height: 80px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
